export default function VglOverzichtTab({ xl }) {
  const { vglView, setVglView, btn } = xl;
  return (
          <div className="flex gap-2 mb-4" data-testid="vgl-toggle">
            <button data-testid="vgl-week-btn" onClick={() => setVglView("week")} className={`rounded-md px-4 py-2 text-sm font-semibold ${vglView === "week" ? "bg-[#1C64B0] text-white" : "border border-slate-300 text-slate-700 hover:bg-slate-50"}`}>Per week</button>
            <button data-testid="vgl-jaar-btn" onClick={() => setVglView("jaar")} className={`rounded-md px-4 py-2 text-sm font-semibold ${vglView === "jaar" ? "bg-[#1C64B0] text-white" : "border border-slate-300 text-slate-700 hover:bg-slate-50"}`}>Per jaar</button>
          </div>
  );
}
